import run from '../../utilities/run';
import $ from 'jquery';

run("#create-api-channel-form", ()=> {
const createApiChannel = $("#create-api-channel-form");
const viewChannelsUrl = createApiChannel.data("view-channel-url");
const apiChannelcancelBtn = $("#create-api-channel-cancel-btn");
const openApiChannelBtn = $("#open-api-channel-button");
const apiUrl = createApiChannel.data("api-url");
const helpCenterUrl =createApiChannel.data("help-center-url"); 
const helpCenterBtn= $("#help-center-button");

apiChannelcancelBtn.click(function(e) {
  location.href=viewChannelsUrl;
});

openApiChannelBtn.click(function(e) {
  window.open(apiUrl);
  location.href=viewChannelsUrl;
});
//Help Center URL calling
helpCenterBtn.click(function(e) {
  window.open(helpCenterUrl);
  location.href=viewChannelsUrl;
});

});



// WEBPACK FOOTER //
// ./src/pages/createChannel/createApiChannel.js